<template>
    <div class="hidden max-w-screen-lg w-full mx-auto p-2 bg-white space-x-4 justify-between items-center md:flex">
        <a
            class="px-4 py-2 hover:bg-gray-200 text-gray-800 font-extrabold text-2xl"
            :href="home"
        >
            🪵 Firewood Match
        </a>

        <slot />
    </div>
</template>

<script>

export default {
    props: {
        home: {
            type: String,
            required: true
        }
    }
}
</script>
